import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import mediaApi from '@/api/media';
import { global_set } from '@/utils';
import { config } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import mangaApi from '@/api/manga';
import { mangaInfoType } from '@/type/manga';

const __default__ = { name: 'parent-path-list' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();

const mediaList = ref<mangaInfoType[]>([]);

function get_last_str(path: string) {
	if (!path) return '无次级目录';

	const arr = path.split('/');

	return arr.reverse()[0]
}
/**
 * @description: 读取媒体库
 * @return {*}
 */
async function load_media() {
	const mediaId = route.query.mediaId;
	const res = await mangaApi.get_sub_path(Number(mediaId));
	mediaList.value = res.list;
}

/**
 * @description: 跳转漫画列表
 * @param {*} mediaId
 * @return {*}
 */
function go_manga_list(mangaInfo: mangaInfoType) {
	const parentPath = mangaInfo.parentPath;

	router.push({
		name: 'manga-list',
		query: {
			byParentPath: 1,
			parentPath,
		},
		params: { clear: '1' },
	});
}

/**
 * @description: 上下文菜单
 * @return {*}
 */
function context_menu() {
	config.rightSidebar = true;
}

// 生命周期
onMounted(async () => {
	load_media();
})


const __returned__ = { route, router, mediaList, get_last_str, load_media, go_manga_list, context_menu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})